import React from "react"
import PropTypes from "prop-types"
import styled from "react-emotion"
import { DragDropContext, DropTarget } from "react-dnd"
import HTML5Backend from "react-dnd-html5-backend"
import "react-sortable-tree/style.css"
import { Button, Container } from "ui"

import LazyLoading from "utils/LazyLoading"

class MenuEditor extends React.Component {
    constructor(props) {
        super(props)
        this.state = { menu: props.menu }
    }

    componentWillReceiveProps({ menu }) {
        this.setState({ menu })
    }

    saveMenu = () => {
        this.props.onChange(this.state.menu)
    }

    render() {
        const getNodeKey = ({ treeIndex }) => treeIndex
        return (
            <LazyLoading getModule={() => import("react-sortable-tree")}>
                {({ SortableTreeWithoutDndContext: SortableTree, changeNodeAtPath }) => (
                    <Container>
                        <div style={{ display: "inline-block", height: 400, width: "60%" }}>
                            <SortableTree
                                treeData={this.state.menu}
                                onChange={menu => this.props.onChange(menu)}
                                dndType={trashAreaType}
                                maxDepth={2}
                                generateNodeProps={({ node, path }) => ({
                                    subtitle: node.url,
                                    title: (
                                        <input
                                            style={{ fontSize: "1.1rem" }}
                                            value={node.name}
                                            onBlur={this.saveMenu}
                                            onChange={event => {
                                                const name = event.target.value

                                                const menu = changeNodeAtPath({
                                                    treeData: this.state.menu,
                                                    path,
                                                    getNodeKey,
                                                    newNode: { ...node, name },
                                                })
                                                this.setState({ menu })
                                            }}
                                        />
                                    ),
                                })}
                            />
                        </div>
                        <div style={{ display: "inline-block", height: 400, width: "40%" }}>
                            <SortableTree
                                treeData={[{ name: "Heading", url: "(Opens Menu)" }]}
                                // onChange={treeOptions => this.setState({ treeOptions })}
                                onChange={() => {}}
                                dndType={trashAreaType}
                                generateNodeProps={({ node, path }) => ({
                                    title: node.name,
                                    subtitle: node.url,
                                })}
                            />
                            <SortableTree
                                treeData={pageListToOptions(this.props.pages)}
                                // onChange={treeOptions => this.setState({ treeOptions })}
                                onChange={() => {}}
                                dndType={trashAreaType}
                                generateNodeProps={({ node, path }) => ({
                                    title: node.name,
                                    subtitle: node.url,
                                })}
                            />
                        </div>
                    </Container>
                )}
            </LazyLoading>
        )
    }
}

const pageListToOptions = pages =>
    pages.map(page => ({
        name: page.name,
        url: page.url,
        pageId: page._sid,
    }))

MenuEditor.propTypes = {
    pages: PropTypes.array.isRequired,
}

export default DragDropContext(HTML5Backend)(MenuEditor)

const trashAreaType = "yourNodeType"
const trashAreaSpec = {
    // The endDrag handler on the tree source will use some of the properties of
    // the source, like node, treeIndex, and path to determine where it was before.
    // The treeId must be changed, or it interprets it as dropping within itself.
    drop: (props, monitor) => ({ ...monitor.getItem(), treeId: "trash" }),
}
const trashAreaCollect = (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }),
})

// The component will sit around the tree component and catch
// nodes dragged out
class trashAreaBaseComponent extends React.Component {
    render() {
        const { connectDropTarget, children, isOver } = this.props

        return connectDropTarget(
            <div
                style={{
                    height: "100vh",
                    padding: 50,
                    background: isOver ? "pink" : "transparent",
                }}
            >
                {children}
            </div>
        )
    }
}
trashAreaBaseComponent.propTypes = {
    connectDropTarget: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    isOver: PropTypes.bool.isRequired,
}
const TrashAreaComponent = DropTarget(trashAreaType, trashAreaSpec, trashAreaCollect)(
    trashAreaBaseComponent
)



// WEBPACK FOOTER //
// ./src/features/studio/components/MenuEditor.js